import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import {
  deleteBranch,
  fetchBranches,
  selectBranches,
  selectBranchesStatus,
} from '@main/features/branches/branchesSlice';
import {
  formatAddressForDisplay,
  formatTextFieldForInput,
} from '@main/features/branches/branchFieldFormat';
import { UiButton, UiLinkButton } from '@shared/common/ui';

export function BranchesPage() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const ownerPgId = useSelector((s) => s.ownerAuth.profile?.id);
  const branches = useSelector(selectBranches);
  const status = useSelector(selectBranchesStatus);
  const [busyId, setBusyId] = useState(null);

  useEffect(() => {
    if (status === 'idle') dispatch(fetchBranches());
  }, [dispatch, status]);

  const onDelete = async (branch) => {
    const ok = window.confirm(
      `Удалить филиал «${branch.name}»? Отвязка от владельца, данные филиала сохранятся.`,
    );
    if (!ok) return;
    setBusyId(branch.id);
    await dispatch(deleteBranch(branch.id));
    setBusyId(null);
  };

  if (status === 'loading' && branches.length === 0) {
    return <div className="placeholder">Загрузка филиалов…</div>;
  }

  return (
    <section>
      <div className="page-header">
        <h1>Филиалы</h1>
        <div className="page-header__spacer" />
        <UiButton
          type="button"
          
          onClick={() => navigate('/profile/branches/new')}
        >
          Добавить филиал
        </UiButton>
      </div>

      {branches.length === 0 ? (
        <div className="placeholder">Пока нет филиалов. Добавьте первый, чтобы начать работу.</div>
      ) : (
        <ul className="branch-list">
          {branches.map((b) => {
            const descriptionText = formatTextFieldForInput(b.description);
            return (
            <li key={b.id} className="branch-card">
              <div className="branch-card__title">{b.name}</div>
              <div className="branch-card__meta">
                {formatAddressForDisplay(b.address) || '— адрес не указан —'}
              </div>
              {descriptionText && (
                <div className="branch-card__meta" style={{ whiteSpace: 'pre-wrap' }}>
                  {descriptionText}
                </div>
              )}
              <div className="branch-card__actions">
                <UiLinkButton to={`/profile/branches/${b.id}`} variant="ghost" size="sm">
                  Изменить
                </UiLinkButton>
                <UiLinkButton
                  to={ownerPgId ? `/${ownerPgId}/crm/${b.id}` : '#'}
                  variant="ghost"
                  size="sm"
                >
                  Открыть 
                </UiLinkButton>
                <UiButton variant="danger" size="sm"
                  type="button"
                  
                  disabled={busyId === b.id}
                  onClick={() => onDelete(b)}
                >
                  {busyId === b.id ? '…' : 'Удалить'}
                </UiButton>
              </div>
            </li>
            );
          })}
        </ul>
      )}
    </section>
  );
}
